import React, { Component } from 'react';
import axios from "axios";

import api from '../../api/';

import Modal from "./Modal.js"

import ParadigmaTable from "../../components/ParadigmaTable/"

class Vendedores extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "loteo_id",
                    id: "loteo_id",
                    accessor: "loteo_id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Vendedor",
                    id: "vendedor_nombre",
                    accessor: d => d.vendedor_nombre,
                    show: true,
                },
                {
                    Header: "Loteo",
                    id: "loteo_nombre",
                    accessor: d => d.loteo_nombre,
                    show: true,
                },
                {
                    Header: "Asignación",
                    id: "asignacion",
                    style:{textAlign:"center"},
                    accessor: d=> d.asignacion,
                    show: true,
                    lookup:"exact",
                    Filter: ({ filter, onChange }) =>(
                         <select
                             onChange={event => onChange(event.target.value)}
                             style={{ width: "100%" }}
                             value={filter ? filter.value : "TODOS"}>
                             <option value="TODOS">TODOS</option>
                             <option value={"ALGUNOS"}>ALGUNOS</option>
                             <option value={"NINGUNO"}>NINGUNO</option>
                         </select>
                    )
                },
            ]
        };
        this.refTable = React.createRef();
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        const refreshTable = () => setTimeout(
             ()=>this.refTable.current != undefined && this.refTable.current != null && this.refTable.current.updateTable(),
             250
        );
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                     {
                        edit: true,
                        component: (props) => <Modal {...props} refreshTable={refreshTable} action="EDIT" />,
                        permission: 'configuracion_vendedores_edit',
                     },
                     {
                        edit: true,
                        component: (props) => <Modal {...props} refreshTable={refreshTable} action="DETAIL" />,
                        permission: 'configuracion_vendedores_detail',
                     },
                ]}
                apiUrl={api.vendedores.vendedores}
                columns={this.state.columns}
                title={"Vendedores"}
            />
        );
    }
}

export default Vendedores;



// WEBPACK FOOTER //
// ./src/views/Vendedores/Vendedores.js